<template>
    <!--
      Submit-level error label: a single, consistent block per form/step for
      controlled errors (frontend validation, Firebase auth, business API errors).
      Uncontrolled API exceptions are NOT shown here — those surface as toasts via
      ErrorService.Resolve. Renders nothing when `message` is empty.
      `role="alert"` so assistive tech announces the error when it appears.
    -->
    <transition name="pretorFormError-fade">
        <p v-if="message" class="pretorFormError" role="alert">
            <i class="bi bi-exclamation-circle-fill pretorFormError__icon"></i>
            <span class="pretorFormError__text">{{ message }}</span>
        </p>
    </transition>
</template>

<script>

export default {
    name: 'PretorFormError',
    props: {
        message: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>

<style scoped>
.pretorFormError {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 14px;
    padding: 10px 12px;
    background-color: #fdecec;
    border: 1px solid #f3c2c2;
    border-radius: 8px;
    font-size: 12.5px;
    line-height: 1.4;
    color: #b3261e;
}

.pretorFormError__icon {
    flex-shrink: 0;
    font-size: 13px;
}

/* Gentle entrance, snappy exit — mirrors the inline field-error motion. */
.pretorFormError-fade-enter-active {
    transition: opacity 200ms cubic-bezier(0.23, 1, 0.32, 1), transform 200ms cubic-bezier(0.23, 1, 0.32, 1);
}

.pretorFormError-fade-leave-active {
    transition: opacity 140ms ease;
}

.pretorFormError-fade-enter-from {
    opacity: 0;
    transform: translateY(-4px);
}

.pretorFormError-fade-leave-to {
    opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
    .pretorFormError-fade-enter-from {
        transform: none;
    }
}
</style>
